export default {
  Dashboard: 'Dashboard',
  DashboardV2: 'DashboardV2',
  SetupDashboard: 'SetupDashboard',
  FourOhFour: 'FourOhFour',
  FiveHundred: 'FiveHundred',
  Forbidden: 'Forbidden'
}
